import * as objectUtils from '../../../utils/object';

import getThumbnail from './get-thumbnail';

import channelTypes from '../../../constants/channel-types';
import urlTypes from '../url-types';


export default function parseChannel(urlType, channelData) {

  const {
    id: externalId,
    snippet = {},
    contentDetails = {},
    statistics = {},
    brandingSettings = {},
    isExternalRemoved = false,
  } = channelData;

  const { title, description, thumbnails, publishedAt } = snippet;
  const { itemCount, relatedPlaylists = {} } = contentDetails;
  const videosCount = Number(itemCount || statistics.videoCount) || 0;

  let coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || getThumbnail(thumbnails) || null;
  if (urlType === urlTypes.PLAYLIST && videosCount === 0) {
    coverUrl = null;
  }

  return objectUtils.removeUndefinedValues({
    externalId,
    uploadsPlaylistId: relatedPlaylists.uploads,
    title,
    description,
    coverUrl,
    videosCount,
    externalCreatedTs: new Date(publishedAt),
    channelType: channelTypes.YOUTUBE_FEED,
    urlType,
    isExternalRemoved,
  });
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/channel.js